<script lang="ts">
  import { isDev } from "../env";
  import { page } from "$app/stores";

  $: error = $page.error as Error;
  $: status = $page.status;
</script>

<svelte:head>
  <title>Error - {status}</title>
</svelte:head>

<main>
  <section class="Content">
    {#if status === 404}
      <h1 class="type-h2">Page Not Found</h1>
      <p>Sorry, this page does not exist!</p>
    {:else if error.message == "Internal Error"}
      <h1 class="type-h2">Unable to Connect</h1>
      <p>
        We had trouble connecting to display this page. Please check your internet connection and
        try again.
      </p>
    {:else}
      <h1 class="type-h2">Oh no!</h1>
      <p>Something went wrong when displaying this page. Please refresh.</p>
    {/if}
  </section>

  {#if isDev}
    <pre class="Trace">{error.stack || `${error.name}:\n${error.message}`}</pre>
  {/if}
</main>

<style>
  main {
    align-items: center;
    display: flex;
    flex: 1 1;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }

  .Content {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    flex: 1 1;
    max-width: 80ch;
    justify-content: center;
    padding: 24px;
  }

  .Trace {
    background: #d9d9d9;
    margin: 0;
    padding: 20px;
    overflow: auto;
    width: 100%;
  }
</style>
